import * as React from "react";
import { Form, Col, Row, Input, Button, Select } from "antd";
import FormControl from "components/Forms/FormControl";
import { FormComponentProps } from "antd/lib/form";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { SubmitButton } from "components/SubmitButton";
import { TrackedBolServiceCategory } from "../../../../Core/Api/Kopp/Api";
export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
    search(bolNumber: string): any; //pass search result
}

export interface State {
}

class BaseTrackedBolSearchBar extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {
        this.setState({});
    }

    onSearch = (event: React.FormEvent) => {
        event.preventDefault();
        this.props.form.validateFieldsAndScroll((error, values: any) => {
            if (!error) {

                this.props.search(values.bolNumber);
                this.props.form.resetFields();
            }
        });
    }


    InputLayout = {

        labelCol: {
            xs: { span: 24, },
            sm: { span: 24, },
            md: { span: 24, },
            lg: { span: 6, },
            xl: { span: 6, },
        },
        wrapperCol: {
            xs: { span: 22 },
            sm: { span: 22, },
            md: { span: 22, },
            lg: { span: 17, },
            xl: { span: 17, },
        },
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="inline" onSubmit={this.onSearch}>
                <Row>
                    <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={[{ required: true, message: 'Please enter a Bill of Lading Number' }]}
                        label="Bill of Lading Number:"
                        labelAlign="left"
                        name="bolNumber">
                        <Input placeholder="Enter BOL" />
                    </FormControl>
                    <Form.Item>
                        <SubmitButton htmlType="submit" style={{ textAlign: "center" }}>Search BOL</SubmitButton>
                    </Form.Item>
                </Row>

            </Form >
        )
    }
}

const TrackedBolSearchBarWithoutRouter = Form.create<Props>({
    name: 'TrackedBolSearchBar',
})(BaseTrackedBolSearchBar);
const TrackedBolSearchBar = withRouter(TrackedBolSearchBarWithoutRouter);
export default TrackedBolSearchBar;
